// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { QuickTreeNode } from '../elements/QuickTree/QuickTreeNode';
import { ThemeManager } from '../misc/ThemeManager';
import { LookupDropDownFormProps, LookupDropDownFormComponentView, LookupDropDownFormViewModel } from './LookupDropDownFormViewModel';
import { Resources } from '@shared/localizations/Resources';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
export class AccountLookupDropDownFormProps extends LookupDropDownFormProps {
}
export class AccountLookupDropDownFormComponentView extends LookupDropDownFormComponentView {
}
export class AccountLookupDropDownFormViewModel extends LookupDropDownFormViewModel {
    get modBtnText() {
        return this.componentView.modBtnText;
    }
    set modBtnText(value) {
        this.updateComponentView('modBtnText', value);
    }
    get checkedSelectedAll() {
        return this.componentView.checkedSelectedAll;
    }
    set checkedSelectedAll(value) {
        this.updateComponentView('checkedSelectedAll', value);
    }
    constructor() {
        super(AccountLookupDropDownFormComponentView);
        this.noRaiseSelectAll = false;
        this.localize();
        this.themeChange();
    }
    fillTree() {
        var _a, _b;
        const items = this.props.items;
        let selectedItem = [];
        if (Array.isArray(this.props.selectedItem)) {
            selectedItem = this.props.selectedItem;
        }
        else {
            selectedItem.push(this.props.selectedItem);
        }
        const selectedNodes = [];
        const nodeArr = [];
        const groupNodeDict = new Map();
        const userNodeDict = new Map();
        const linkedAccountsNode = new QuickTreeNode(Resources.getResource('TerceraAccountLookup.Linked accounts'));
        linkedAccountsNode.collapsed = false;
        linkedAccountsNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsed.image;
        linkedAccountsNode.collapsedImageSelected =
            ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsedSelected.image;
        linkedAccountsNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsExpanded.image;
        linkedAccountsNode.expandedImageSelected =
            ThemeManager.NewImages.quickTreeIconLinkedAccountsExpandedSelected.image;
        const isAdmin = RulesSet.TERMINAL_HTML;
        const len = items.length;
        for (let i = 0; i < len; i++) {
            const account = items[i];
            if (!this.props.showMAM && account.isMAM) {
                continue;
            }
            const userLogin = account.userLogin;
            const group = DataCache.GetUserGroupById((_a = account.User) === null || _a === void 0 ? void 0 : _a.GroupId);
            const groupName = group === null || group === void 0 ? void 0 : group.GroupName;
            const accountToString = account.toString(true);
            // Filtering.
            if (isValidString(this.currentNameFilter)) {
                const curItemFindStr = accountToString.toLowerCase();
                const filterString = this.currentNameFilter.toLowerCase();
                if (!curItemFindStr.includes(filterString)) {
                    continue;
                }
            }
            const accountNode = new QuickTreeNode(accountToString);
            const isAccountItemAll = (_b = selectedItem[0]) === null || _b === void 0 ? void 0 : _b._AccountItemAll;
            if (selectedItem.includes(account) || isAccountItemAll) {
                selectedNodes.push(accountNode);
            }
            accountNode.tag = account;
            accountNode.visible = true;
            accountNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconAccountCollapsed.image;
            accountNode.collapsedImageSelected = ThemeManager.NewImages.quickTreeIconAccountCollapsedSelected.image;
            accountNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconAccountExpanded.image;
            accountNode.expandedImageSelected = ThemeManager.NewImages.quickTreeIconAccountExpandedSelected.image;
            let groupNode = groupNodeDict.get(groupName);
            if (isAdmin && isValidString(groupName) && isNullOrUndefined(groupNode)) {
                groupNode = new QuickTreeNode(groupName);
                groupNode.collapsed = false;
                groupNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconUserGroupCollapsed.image;
                groupNode.collapsedImageSelected = ThemeManager.NewImages.quickTreeIconUserGroupCollapsedSelected.image;
                groupNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconUserGroupExpanded.image;
                groupNode.expandedImageSelected = ThemeManager.NewImages.quickTreeIconUserGroupExpandedSelected.image;
                groupNodeDict.set(groupName, groupNode);
            }
            if (account.isLinked) {
                linkedAccountsNode.AddChildNode(accountNode);
            }
            else if (isValidString(userLogin)) {
                let userNode = userNodeDict.get(userLogin);
                if (isNullOrUndefined(userNode)) {
                    userNode = new QuickTreeNode(userLogin);
                    userNode.collapsed = false;
                    userNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsed.image;
                    userNode.collapsedImageSelected =
                        ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsedSelected.image;
                    userNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsExpanded.image;
                    userNode.expandedImageSelected =
                        ThemeManager.NewImages.quickTreeIconLinkedAccountsExpandedSelected.image;
                    userNodeDict.set(userLogin, userNode);
                    if (!isNullOrUndefined(groupNode)) {
                        groupNode.AddChildNode(userNode);
                    }
                    else {
                        nodeArr.push(userNode);
                    }
                }
                userNode.AddChildNode(accountNode);
            }
            else {
                nodeArr.push(accountNode);
            }
        }
        nodeArr.push(...this.getCorrectNodesArrayFromMap(groupNodeDict));
        AccountLookupDropDownFormViewModel.sortNodes(nodeArr);
        if (linkedAccountsNode.childNodes.length > 0) {
            nodeArr.push(linkedAccountsNode);
        }
        this.quickTree.Clear();
        if (nodeArr.length === 1 && isValidArray(nodeArr[0].childNodes)) {
            this.quickTree.AddNodeRange(nodeArr[0].childNodes);
        }
        else {
            this.quickTree.AddNodeRange(nodeArr);
        }
        const ims = this.quickTree.isMultiSelectCheckboxUsing;
        for (let i = 0; i < selectedNodes.length; i++) {
            if (ims) {
                this.quickTree.setCheckedNode(selectedNodes[i]);
            }
            else {
                this.quickTree.setSelectedNode(selectedNodes[i], true);
            }
        }
        this.quickTree.goToSelectedNode();
        this.raiseOnResizeQuickTree();
        this.quickTree.Draw();
    }
    localize() {
        super.localize();
        this.modBtnText = Resources.getResource('TerceraAccountLookup.Select');
    }
    onCheckAllStateChange(isSelectedAll) {
        this.checkedSelectedAll = isSelectedAll;
        if (this.noRaiseSelectAll) {
            this.noRaiseSelectAll = false;
            return;
        }
        if (!isNullOrUndefined(this.quickTree)) {
            if (this.quickTree.isMultiSelectCheckboxUsing) {
                this.quickTree.CheckUnCheckAllMultiCheckbox(this.checkedSelectedAll);
            }
            else {
                this.quickTree.CheckUnCheckAll(this.checkedSelectedAll);
            }
        }
    }
    selectionChanged() {
        super.selectionChanged();
        const qt = this.quickTree;
        if (!isValidArray(this.props.items) || isNullOrUndefined(qt)) {
            return;
        }
        const selectedNum = Object.keys(qt.selectedNodesDict).length;
        const selectedAll = selectedNum === this.props.items.length;
        if (this.isShowFooterBtn()) {
            if (this.checkedSelectedAll !== selectedAll) // select all cb checked state changed
             {
                this.noRaiseSelectAll = true;
            }
            this.checkedSelectedAll = selectedAll;
        }
    }
    isShowFooterBtn() {
        var _a;
        return ((_a = this.props) === null || _a === void 0 ? void 0 : _a.showButtons) || this.isMultiSelect;
    }
    getCorrectNodesArrayFromMap(map) {
        const result = [];
        const group = Array.from(map.values());
        for (const node of group) {
            const childNodes = [...node.childNodes];
            for (const childNode of childNodes) {
                if (childNode.childNodes.length === 1) {
                    const singleChildNode = childNode.childNodes[0];
                    node.RemoveChildNode(childNode);
                    node.AddChildNode(singleChildNode);
                }
            }
            result.push(node);
        }
        return result;
    }
    static sortNodes(nodes) {
        if (isNullOrUndefined(nodes))
            return;
        nodes.sort(AccountLookupDropDownFormViewModel.sortItems);
        const len = nodes.length;
        for (let i = 0; i < len; i++) {
            AccountLookupDropDownFormViewModel.sortNodes(nodes[i].childNodes);
        }
    }
    static sortItems(i1, i2) {
        const acc1 = i1.tag;
        const acc2 = i2.tag;
        if (isNullOrUndefined(acc1) || isNullOrUndefined(acc2)) {
            return i1.nodeText.toLowerCase().localeCompare(i2.nodeText.toLowerCase());
        }
        if (acc1.isLinked && !acc2.isLinked) {
            return 1;
        }
        else if (!acc1.isLinked && acc2.isLinked) {
            return -1;
        }
        else {
            return acc1.FullAccString.toLowerCase().localeCompare(acc2.FullAccString.toLowerCase());
        }
    }
}
